import "./MovementBodyAndRhythm.module.css";
import Header from "@/reusable_sections/Header";
import MovementSomaticAwarenessFlow from "./sections/MovementSomaticAwarenessFlow";
import Footer from "@/reusable_sections/Footer";
export default function MovementBodyAndRhythmPage() {
  return <div>
      <Header />
      <MovementSomaticAwarenessFlow />
      <Footer />
    </div>;
}